import { useState, type DragEvent } from 'react';
import { cx } from '../cx';

export function Dropzone({
  files,
  onFiles,
  accept,
  multiple = true,
  hint,
}: {
  files: File[];
  onFiles: (files: File[]) => void;
  accept?: string;
  multiple?: boolean;
  /** o que este envio aceita, quando não é tudo */
  hint?: string;
}) {
  const [over, setOver] = useState(false);
  const add = (list: FileList | null) => {
    if (!list) return;
    const next = Array.from(list);
    onFiles(multiple ? [...files, ...next] : next.slice(0, 1));
  };
  const onDrop = (e: DragEvent) => {
    e.preventDefault();
    setOver(false);
    add(e.dataTransfer.files);
  };
  return (
    <div className="rr-stack rr-stack--3">
      <label
        className={cx('rr-drop', over && 'rr-drop--over')}
        onDragOver={(e) => {
          e.preventDefault();
          setOver(true);
        }}
        onDragLeave={() => setOver(false)}
        onDrop={onDrop}
      >
        <input type="file" accept={accept} multiple={multiple} onChange={(e) => add(e.target.files)} />
        <span className="rr-drop__title">solte arquivos aqui ou clique para escolher</span>
        <span className="rr-drop__hint">{hint ?? 'PDF · DOCX · PPTX · XLSX · CSV · imagem · áudio · vídeo · texto'}</span>
      </label>
      {files.length > 0 && (
        <div className="rr-stack rr-stack--2">
          {files.map((f, i) => (
            <div key={`${f.name}-${i}`} className="rr-file-row">
              <span>{f.name}</span>
              <span className="rr-row">
                <span className="rr-faint">{(f.size / 1024 / 1024).toFixed(1)} MB</span>
                <button type="button" className="rr-close" style={{ width: 24, height: 24 }} aria-label="Remover" onClick={() => onFiles(files.filter((_, j) => j !== i))}>
                  ×
                </button>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
